<script>
	import PageHeader	from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Parcelinha Digital';
</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container">
	<div class="grid grid-size--2 grid-size-sm--1 gap-10 pb-30">
		<div class="text-center">
			<a href="https://parcelinhadigital.duplex.com.br/" target="_blank" title="Simulação">
				<img src="/assets/images/parcelinhaCartao.png" alt="Parcelinha Digital Cartão" style="max-height: 195px; width: 100%; max-width: 581px; margin-bottom: 20px;">
			</a>
		</div>
		<div class="text-center">
			<a href="https://parcelinhadigital.duplex.com.br/" target="_blank" title="Simulação">
				<img src="/assets/images/parcelinhaCupom.png" alt="Parcelinha Digital Cupom" style="max-height: 195px; width: 100%; max-width: 348px; margin-bottom: 20px;">
			</a>
		</div>
	</div>
	<p>Olá, tudo bem?</p>
	<p>Estamos sempre em busca de soluções que façam sentido para nossos clientes e, por isso, agora oferecemos para você essa super
parceria entre Bona Imóveis e Duplex! Descubra um pouco sobre como ela pode te ajudar:</p>
	<p>A Duplex surgiu para que consumidores tenham mais liberdade e possibilidades de pagamento no meio condominial. A partir da
solução <b>Duplex | Parcelinha Digital</b>, você pode parcelar seus boletos de aluguel ou condomínio em até <b>12x no cartão de crédito!</b></p>
	<p class="pt-15"><b>COMO FUNCIONA?</b></p>
	<p>Você simula a transação no site, pode selecionar para pagar o boleto em até 12x e usar até quatro cartões de crédito.
Com essa parceria, conquistamos o cupom <b>BONAIMOVEIS</b>, que garante aos nossos clientes um desconto super bacana na taxa de
serviço!</p>
	<p>Procuramos soluções financeiras com atenção às necessidades de nossos síndicos e condôminos, e por fim, encontramos este serviço de
parcelamento extremamente seguro e fácil.</p>
	<p>
		<center>
			<a class="btn btn-primary" href="https://parcelinhadigital.duplex.com.br/" target="_blank" title="Simulação" style="font-size:18px;text-transform:uppercase;padding: 20px 40px; border-radius: 40px; background-color: #2cc062; border-color: #2cc062;">Quero Fazer uma Simulação</a>
		</center>
	</p>
	<p>Não se preocupe se você não estiver com seu boleto em mãos! Solicite ajuda para nosso time de atendimento ou acesse o nosso portal
para emitir a segunda via.</p>
	<p>Um abraço, equipe Bona Imóveis.</p>

	<div class="grid grid-size--2 grid-size-sm--1 gap-10 pt-30">
		<div class="text-center">
			<a href="https://parcelinhadigital.duplex.com.br/" target="_blank" title="Simulação">
				<img src="/assets/images/parcelinhaCartao.png" alt="Parcelinha Digital Cartão" style="max-height: 195px; width: 100%; max-width: 581px; margin-bottom: 20px;">
			</a>
		</div>
		<div class="text-center">
			<a href="https://parcelinhadigital.duplex.com.br/" target="_blank" title="Simulação">
				<img src="/assets/images/parcelinhaCupom.png" alt="Parcelinha Digital Cupom" style="max-height: 195px; width: 100%; max-width: 348px; margin-bottom: 20px;">
			</a>
		</div>
	</div>
</div>